import { useQuestionDescription } from "../../behaviours/useQuestionDescription";
const HostScreenDescription = ({ id }) => {
    return useQuestionDescription({ id });
};
export { HostScreenDescription };
